import { baseCRUDAPI } from './base';

export default class User extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'User');
  }

  getUser({ email, verificationCode }) {
    return this.axiosObject.get(this.apiBaseName, {
      params: {
        email,
        verificationCode,
      },
    });
  }
}
